import React, { useState } from 'react';
import PropTypes from 'prop-types';

const StickyNote = ({ title, message, color }) => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleOpen = () => {
        setIsOpen(!isOpen);
    };

    const noteStyle = {
        backgroundColor: color,
        padding: '10px',
        borderRadius: '5px',
        width: '200px',
        height: isOpen ? '200px' : '40px', // Adjust height based on open state
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        textAlign: 'center',
        fontSize: '12px',
        cursor: 'pointer', // Add cursor pointer to indicate clickable
    };

    return (
        <div style={noteStyle} onClick={toggleOpen}>
            <h3>{title}</h3>
            {isOpen && <p>{message}</p>}
        </div>
    );
};

StickyNote.propTypes = {
    title: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
};

export default StickyNote;